import ValidatedSearchProcessor from './ValidatedSearchProcessor';

export default ValidatedSearchProcessor;
